import PropTypes from "prop-types";
import styles from "./VoteCount.module.css";

/**
 * View Component. Displays the number of votes made out of the total
 */
export function VoteCount({ votesMade, totalVotes }) {
  return (
    <>
      <div className={styles.label}>Votes:</div>
      <div className={styles.votes}>
        {votesMade}/{totalVotes}
      </div>
    </>
  );
}

VoteCount.propTypes = {
  votesMade: PropTypes.number,
  totalVotes: PropTypes.number,
};
